import React from "react";
import "./common.css";
import CustomInput from "./CustomInput";

class SingleRow extends React.Component {
  state = {};
  constructor() {
    super();
    this.changes = {};
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.jsonObj !== prevState.layout) {
      return { layout: nextProps.jsonObj }; // <- this is setState equivalent
    } else {
      return null;
    }
  }
  getInputNewData = (property, value) => {
    this.changes[property] = value;
    this.props.setCardsInfo(this.changes, this.state.layout.title);
  };
  renderInputs = () => {
    if (this.state.layout !== undefined) {
      const item = this.state.layout.items.map((item, key) => {
        if (this.state[item.item.intemName] !== item) {
          this.setState({ [item.item.intemName]: item });
        }
        return (
          <CustomInput
            key={key}
            item={item}
            minWidth={item.size ? item.size : "50%"}
            size={item.size}
            handleNewData={this.getInputNewData}
          />
        );
      });
      return item;
    }
  };
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flex: 1
        }}
      >
        {this.renderInputs()}
      </div>
    );
  }
}

export default SingleRow;
